// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
body {
  background-color: #f8f9fa; /* Couleur de fond douce */
  font-family: 'Arial', sans-serif; /* Police de caractères */
}

.App {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,0BAA0B;EACrD,gCAAgC,EAAE,yBAAyB;AAC7D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":["/* src/App.css */\nbody {\n  background-color: #f8f9fa; /* Couleur de fond douce */\n  font-family: 'Arial', sans-serif; /* Police de caractères */\n}\n\n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
